import { useSelector } from 'react-redux'
import React, { useMemo } from 'react'
import { useInView } from 'react-intersection-observer'
import { useResponsive } from '../../hooks'
import { ReduxState } from '../../store/reducers'
import { Intent } from '../../@types/intent'
import { RealEstateType } from '../../@types/realEstateType'
import { FeatureName, getFeatureToggleValue } from '../../featureToggles/featureToggles'
import { TuvSealSection } from '../TUVSealSection/TUVSealSection'
import { IntegrationType } from '../../@types/config'
import { WizardFlowType } from '../../@types/wizardFlowType'
import BulletPoints from '../BulletPoints/BulletPoints'

export const Footer = () => {
  const { isMobile } = useResponsive()
  const { ref, inView } = useInView({})
  const {
    config: { theme, wordings, integrationType },
    lead: { realEstateType, intent, extendedBuyerLead },
    animation: { animationClass },
    flow: { wizardFlowType },
  } = useSelector((state: ReduxState) => state)
  const isIv24Integration = integrationType === IntegrationType.IMMOVERKAUF24
  const contentAnimationStyles = { opacity: inView ? 1 : 0 }

  const enableCustomWordings = useMemo(() => {
    return (
      intent &&
      [Intent.MAKLER_SALE, Intent.MAYBE_MAKLER_SALE].includes(intent) &&
      realEstateType &&
      realEstateType !== RealEstateType.COMMERCIAL
    )
  }, [intent, realEstateType])
  const isSellWithoutRealtor = getFeatureToggleValue(FeatureName.IS_SELL_WITHOUT_REALTOR)
  const isConsultationScreen = isSellWithoutRealtor && intent === Intent.INDEPENDENT_SALE

  return (
    <div ref={ref} style={contentAnimationStyles} className={`${animationClass} `} data-testid='footer'>
      <BulletPoints
        checkmarkColor={theme?.primary}
        bulletPointOne={
          enableCustomWordings && wordings?.contactForm.bulletPointOne === ''
            ? undefined
            : wizardFlowType === WizardFlowType.SOLAR
            ? 'Kostenlos & unverbindlich'
            : extendedBuyerLead || intent === Intent.BUY
            ? 'Makler kontaktieren dich bevorzugt'
            : isConsultationScreen
            ? 'Persönlich & individuell'
            : wordings?.contactForm.bulletPointOne
            ? wordings.contactForm.bulletPointOne
            : 'Unverbindliche Empfehlung'
        }
        bulletPointTwo={
          enableCustomWordings && wordings?.contactForm.bulletPointTwo === ''
            ? undefined
            : wizardFlowType === WizardFlowType.SOLAR
            ? 'Persönliche Beratung'
            : extendedBuyerLead || intent === Intent.BUY
            ? 'Passend zu deinem Finanzierungsrahmen'
            : isConsultationScreen
            ? 'Kostenlos & unverbindlich'
            : wordings?.contactForm.bulletPointTwo
            ? wordings.contactForm.bulletPointTwo
            : 'Nur geprüfte Makler'
        }
        bulletPointThree={
          enableCustomWordings && wordings?.contactForm.bulletPointThree === ''
            ? undefined
            : wizardFlowType === WizardFlowType.SOLAR
            ? '100% Ökostrom'
            : extendedBuyerLead || intent === Intent.BUY
            ? 'Schneller zum Besichtigungstermin'
            : isConsultationScreen
            ? 'Zeitnahe Rückmeldung'
            : wordings?.contactForm.bulletPointThree
            ? wordings.contactForm.bulletPointThree
            : 'Ohne versteckte Kosten'
        }
      />
      {isMobile && (extendedBuyerLead || intent === Intent.BUY || isIv24Integration || isConsultationScreen) && (
        <TuvSealSection />
      )}
    </div>
  )
}
